export default __webpack_public_path__ + "static/media/leader_notes.c24de725.pdf";